'use client';

import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import Slider from 'react-slick';

interface CarouselImage {
  url: string;
  eventId: string;
}

interface Props {
  images: CarouselImage[];
  isArrow?: boolean;
  onImageClick?: (eventId: string) => void;
}

const Carrousel: React.FC<Props> = ({ images, isArrow = false, onImageClick }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: isArrow,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const wrapInLink = !!onImageClick;

  // If there's only one image, render it directly without the carousel
  if (images.length === 1) {
    const img = (
      <img
        src={images[0].url}
        alt="Single image"
        className="w-full object-cover rounded-3xl cursor-pointer aspect-[1920/700]"
      />
    );
    return (
      <div className="w-full relative">
        {wrapInLink ? (
          <a
            href={`/events/${images[0].eventId}`}
            onClick={(e) => {
              e.preventDefault();
              onImageClick(images[0].eventId);
            }}
            className="block"
          >
            {img}
          </a>
        ) : (
          img
        )}
      </div>
    );
  }

  return (
    <Slider {...settings}>
      {images.map((image, index) => (
        wrapInLink ? (
          <a
            key={image.eventId || index}
            href={`/events/${image.eventId}`}
            onClick={(e) => {
              e.preventDefault();
              onImageClick(image.eventId);
            }}
            className="block"
          >
            <img
              src={image.url}
              alt={`Slide ${index}`}
              className="w-full object-cover rounded-3xl cursor-pointer aspect-[1920/700]"
            />
          </a>
        ) : (
          <img
            key={image.eventId || index}
            src={image.url}
            alt={`Slide ${index}`}
            className="w-full object-cover rounded-3xl cursor-pointer aspect-[1920/700]"
          />
        )
      ))}
    </Slider>
  );
};

export default Carrousel;
